import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store";
import {
    HOME,
    GUIDE,
    DEVELOPER,
    DEVELOPER_WELCOME,
    DEVELOPER_REGISTER,
    DEVELOPER_PROJECTS,
    DEVELOPER_PROJECT_REGISTER,
    DEVELOPER_PROJECT_JOIN,
    DEVELOPER_PROJECT_DETAIL,
    APP_CONSOLE
} from "./path";
import { getLoginURL } from "@/data/links";

Vue.use(VueRouter);

const routes = [
    {
        path: HOME,
        name: "home",
        component: () => import("@/views/Home.vue")
    },
    {
        path: `${GUIDE}/:name?/:version?`,
        name: "guide",
        component: () => import("@/views/Guide.vue")
    },
    {
        path: DEVELOPER_REGISTER,
        name: "developerRegister",
        component: () => import("@/views/DeveloperRegister.vue"),
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            next(store.getters.isDeveloper ? HOME : true);
        }
    },
    {
        path: DEVELOPER_WELCOME,
        name: "welcome",
        component: () => import("@/views/Welcome.vue"),
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            next(store.getters.isDeveloper ? HOME : true);
        }
    },
    {
        path: APP_CONSOLE,
        name: "appConsole",
        component: () => import("@/views/AppConsole.vue")
    },
    {
        path: DEVELOPER,
        component: () => import("@/views/developer/Developer.vue"),
        redirect: DEVELOPER_PROJECTS,
        children: [
            {
                path: `${DEVELOPER_PROJECT_DETAIL}/:pId/apps/new`,
                name: "appRegister",
                component: () => import("@/views/developer/AppRegister.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true,
                    requiresProject: true,
                    requiresApprovedProject: true
                }
            },
            {
                path: `${DEVELOPER_PROJECT_DETAIL}/:pId/apps/:aId/:tab?`,
                name: "appDetail",
                component: () => import("@/views/developer/AppDetail.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true,
                    requiresProject: true,
                    requiresApprovedProject: true
                }
            },
            {
                path: DEVELOPER_PROJECTS,
                name: "projects",
                component: () => import("@/views/developer/Projects.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true
                }
            },
            {
                path: DEVELOPER_PROJECT_REGISTER,
                name: "projectRegister",
                component: () =>
                    import("@/views/developer/ProjectRegister.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true
                }
            },
            {
                path: DEVELOPER_PROJECT_JOIN,
                name: "projectJoin",
                component: () => import("@/views/developer/ProjectJoin.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true
                }
            },
            {
                path: `${DEVELOPER_PROJECT_DETAIL}/:pId?/:tab?/:pageType?`,
                name: "projectDetail",
                component: () => import("@/views/developer/ProjectDetail.vue"),
                meta: {
                    requiresAuth: true,
                    requiresDeveloper: true,
                    requiresProject: true
                }
            }
        ]
    },
    {
        path: "*",
        redirect: "/"
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async ({ name, params, path, meta }, from, next) => {
    const { initial } = store.state.user;
    if (initial) {
        await store.dispatch("FETCH_PROFILE");
    }

    const { isLoggedIn, isDeveloper } = store.getters;
    if (meta.requiresAuth && !isLoggedIn) {
        location.href = getLoginURL(`${location.origin}${path}`);
    }
    if (meta.requiresDeveloper && !isDeveloper) {
        return next(DEVELOPER_REGISTER);
    }

    if (isDeveloper) {
        if (
            initial ||
            !(name === "guide" || name === "appDetail" && params.tab)
        ) {
            await store.dispatch("FETCH_MY_PROJECTS");
            if (store.getters.hasApprovedProject) {
                await store.dispatch("FETCH_APPS");
            }
        }
    }

    const { hasProject, hasApprovedProject } = store.getters;
    if (meta.requiresProject && !hasProject) {
        return next(DEVELOPER_PROJECTS);
    }
    if (meta.requiresApprovedProject && !hasApprovedProject) {
        return next(DEVELOPER_PROJECTS);
    }
    next();
});

export default router;
